import { Injectable, inject } from '@angular/core';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import {
  AccessoriesPagePayload,
  AccessoriesSummary,
  AccessoriesSummaryFacadeService,
} from '@rogers/self-serve-accessories';
import { ACCESSORIES_ROUTE } from '@rci/self-serve-fido/app.constant';
import { AccountListFacadeService } from '@rogers/self-serve-common/account';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccessoriesService {
  private readonly accessoriesSummaryFacadeService = inject(AccessoriesSummaryFacadeService);
  private readonly accountListFacadeService = inject(AccountListFacadeService);
  private readonly routingService = inject(RoutingService);

  private _accessoriesPagePayload: AccessoriesPagePayload;

  get accessoriesPagePayload() {
    return this._accessoriesPagePayload;
  }

  getAccessoriesSummary$(accountNumber: string) {
    return this.accessoriesSummaryFacadeService.getAccessoriesSummary$(accountNumber);
  }

  loadAccessoriesSummary$() {
    return this.accountListFacadeService.accountList$.pipe(
      tap(accounts => {
        accounts
          .filter(
            account =>
              account.isWirelessOrConsolidatedAccount && (account.isActiveAccount || account.isSuspendedAccount),
          )
          .forEach(account =>
            this.accessoriesSummaryFacadeService.loadAccessoriesSummary(account.accountNumber, account.alias),
          );
      }),
    );
  }

  navigateToAccessoriesPage(accessoriesSummary: AccessoriesSummary, language: string) {
    const { accountAlias, accountNumber, subscriptionAlias } = accessoriesSummary;
    this._accessoriesPagePayload = {
      accountAlias,
      accountNumber,
      language,
      subscriptionAlias,
    };
    this.routingService.navigate(ACCESSORIES_ROUTE);
  }
}
